/**
 * Hooks utilitários de UI para superfícies LiveView.
 */

export const FileDownload = {
  mounted() {
    this.handleEvent('download', ({ filename, content, content_base64, mime_type }) => {
      if ((content || content_base64) && mime_type) {
        try {
          let data;
          if (content_base64) {
            const bin = atob(content_base64);
            const len = bin.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);
            data = bytes;
          } else {
            data = [content];
          }

          const blob = new Blob([data], { type: mime_type });
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.download = filename || 'download';
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
          window.URL.revokeObjectURL(url);
          return;
        } catch (_) { }
      }
    });

    this.handleEvent('download', ({ url, filename }) => {
      if (!url) return;

      const anchor = document.createElement('a');
      anchor.href = url;
      if (filename) anchor.download = filename;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    });
  }
};

export const DiningHallDropdown = {
  mounted() {
    this.syncWidth();
  },

  updated() {
    this.syncWidth();
  },

  syncWidth() {
    const calcElement = document.getElementById('dining-hall-width-calc');
    const buttonElement = document.getElementById('dining-hall-dropdown-button');
    const contentElement = document.getElementById('dining-hall-dropdown-content');

    if (calcElement && buttonElement && contentElement) {
      requestAnimationFrame(() => {
        const maxWidth = calcElement.offsetWidth;
        if (maxWidth > 0) {
          const finalWidth = maxWidth + 60;
          buttonElement.style.width = `${finalWidth}px`;
          contentElement.style.width = `${finalWidth}px`;
        }
      });
    }
  }
};

export const DashboardTabs = {
  mounted() {
    this.handleEvent('persist_dining_hall_tab', ({ dining_hall_id, timestamp }) => {
      try {
        sessionStorage.setItem('mealflow_selected_dining_hall_tab', dining_hall_id.toString());
        sessionStorage.setItem('mealflow_selected_dining_hall_tab_timestamp', timestamp.toString());
      } catch (e) {
        console.warn('[DashboardTabs] Failed to persist tab selection:', e);
      }
    });

    try {
      const savedTabId = sessionStorage.getItem('mealflow_selected_dining_hall_tab');
      if (savedTabId) {
        this.pushEvent('restore_tab_selection', { dining_hall_id: parseInt(savedTabId, 10) });
      }
    } catch (e) {
      console.warn('[DashboardTabs] Failed to restore tab selection:', e);
    }
  }
};

export const LiveViewUiHooks = {
  FileDownload,
  DiningHallDropdown,
  DashboardTabs
};
